export default "__VITE_ASSET__b0d960d4__"